module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-video-05.3dfcf293.jpg";